const PathConstants = {
  Home: "https://www.getclaimable.com/",
  Root: "/",

  // Account
  AccountOverview: "/account",
  Appeals: "/appeals",

  // Report Appeal Result Flow
  ReportAppealResult: "/report-appeal-result/:appealId",
  AppealWon: "/appeal-won",
  ReviewAndShare: "/review-and-share",
  NoResultNotEnoughTime: "https://www.getclaimable.com/have-you-heard-back",
  NoResultShouldHaveHeardBack:
    "https://www.getclaimable.com/should-have-heard-back",
  DenialUpheld: "/denial-upheld",
  DenialUpheldClaimFile: "/denial-upheld-claim-file",
  AppealLost: "/appeal-lost",
  NotifyMe: "https://www.getclaimable.com/notify-me",

  // Eligibility Flow

  MedicationConditionEligibility: "/medication-condition-eligibility",
  DenialReasonEligibility: "/denial-reason-eligibility",
  EligibilitySuccess: "/eligibility-success",
  PatientInfo: "/patient-info",
  NiceToMeetYou: "/nice-to-meet-you",
  NotifyMeDenial: "https://www.getclaimable.com/notify-me-denial",

  // Setup Flow

  LetsGetStarted: "/lets-get-started",
  UploadLetter: "/your-denial-letter",
  UploadInsuranceCard: "/your-insurance-card",
  UploadProcessing: "/processing-supporting-data",
  ConfirmInsuranceDetails: "/confirm-insurance-details",
  PrimaryEnrollee: "/primary-enrollee",
  DenyingPartyPage: "/denying-party",
  OtherAppealSituationsPage: "/other-appeal-situations",

  // Experience Flow

  AppealSurvey: "/appeal-survey",
  ExperienceOverview: "/your-experience",
  ExperienceSummary: "/nearly-complete",

  // Letter Creation Flow

  LetterBuildingInterstitial: "/getting-ready",
  AppealOverview: "/appeal-overview",
  PreviewComplete: "/ready-to-send",
  PreviewAndReviewAppealLetter: "/review-your-appeal-letter",
  AttachDoctorStatement: "/attach-doctor-statement",
  PatientData: "/patient-data",
  AppealDepartment: "/appeal-department",
  EmployerAddress: "/employer-address",
  CcDestinations: "/cc-destinations",

  // Payment Flow

  PrePayment: "/pre-payment",
  PaymentComplete: "/purchase-complete",
  NotFound: "*",

  // Resume

  ResumeAppeal: "/resume-appeal/:appealId",
};

export default PathConstants;
